<script lang="ts" setup>
import { useDebounceFn } from "@vueuse/core"
import Decimal from "decimal.js"
import { MoneyToMessageInputTypeEnum } from "~/utils/generated/api"

defineEmits<{
	click: [amount?: number]
}>()

const perMoneyValue = ref<number[]>([0])
const perMessageValue = ref<number[]>([0])
const api = useApi()
const loading = ref<boolean>(false)

const changeMoneyAmountDebounce = useDebounceFn(async () => {
	loading.value = true
	const { data } = await api.credit.moneyToMessageAndViceVerse({
		amount: perMoneyValue.value[0] ? new Decimal(perMoneyValue.value[0]).toString() : String(0),
		type: MoneyToMessageInputTypeEnum.Money,
	})

	perMessageValue.value[0] = Number(data.message)
	loading.value = false
})

const changeMessageAmountDebounce = useDebounceFn(async () => {
	loading.value = true
	const { data } = await api.credit.moneyToMessageAndViceVerse({
		amount: perMessageValue.value[0] ? new Decimal(perMessageValue.value[0]).toString() : String(0),
		type: MoneyToMessageInputTypeEnum.Message,
	})

	perMoneyValue.value[0] = Number(data.money)
	loading.value = false
})

async function changeMoneyAmount() {
	await changeMoneyAmountDebounce()
}

async function changeMessageAmount() {
	await changeMessageAmountDebounce()
}
</script>

<template>
	<div
		data-aos="fade-up"
		class="relative min-h-[440px] w-[335px] border-3 border-website-primary rounded-xl border-solid bg-background p-5">
		<Icon
			v-if="loading"
			name="i-svg-spinners:180-ring-with-bg"
			class="absolute end-1 top-1 size-6" />

		<div class="mb-6 border-b-2 border-foreground/15 pb-6">
			<h3 class="text-lg font-bold">
				اعتباری
			</h3>

			<p class="mt-1 text-sm text-foreground/80">
				پلن پیشنهادی برای کاربرانی که مدیریت بهتری روی مصرف خود دارند
			</p>
		</div>

		<div>
			<div
				class="flex items-center justify-between">
				<span class="mb-2">تعداد پیام</span>

				<span
					v-if="perMessageValue[0]">{{ Math.round(perMessageValue[0]) }} عدد</span>

				<span v-else>0</span>
			</div>

			<WebSlider
				v-model="perMessageValue"
				:max="1300"
				:min="0"
				:step="10"
				class="mt-2"
				@update:model-value="changeMessageAmount" />
		</div>

		<div class="mt-4">
			<div
				class="mb-2 flex items-center justify-between">
				<span>هزینه نهایی</span>

				<span v-if="perMoneyValue[0]">{{ Math.round(perMoneyValue[0] / 1000) }} هزار تومان</span>

				<span v-else>0</span>
			</div>

			<Icon
				v-if="loading"
				class="mt-2 size-5 h-[36px]"
				name="i-svg-spinners:180-ring-with-bg" />

			<WebSlider
				v-model="perMoneyValue"
				:max="1000000"
				:min="0"
				:step="1000"
				class="mt-2"
				@update:model-value="changeMoneyAmount" />
		</div>

		<div class="mt-5">
			<p class="mb-2 text-center text-xs">
				تعداد پیام و یا هزینه نهایی رو به مقدار دلخواهت تغییر بده
			</p>

			<Btn
				class="h-8 w-full bg-website-primary text-white hover:bg-website-primary/50"
				@click="$emit('click', perMoneyValue[0])">
				برو بریم !
			</Btn>
		</div>

		<div class="mt-5">
			<h4 class="text-sm">
				امکانات اشتراک:
			</h4>

			<ul class="list-none ps-0 text-xs">
				<li class="mb-1 flex items-center gap-2 ps-0">
					<NuxtImg
						src="/icons/check.svg"
						width="24"
						height="24" />
					پشتیبانی از مدل Gpt 4o
				</li>

				<li class="mb-1 flex items-center gap-2 ps-0">
					<NuxtImg
						src="/icons/check.svg"
						width="24"
						height="24" />
					پشتیبانی از مدل Gpt 4o Mini
				</li>
			</ul>
		</div>
	</div>
</template>
